import { render, staticRenderFns } from "./serveState.vue?vue&type=template&id=2472d836&scoped=true"
import script from "./serveState.vue?vue&type=script&lang=js"
export * from "./serveState.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2472d836",
  null
  
)

export default component.exports